import * as React from "react";
import { Button } from "../button/button.mjs";
import { ClickArea } from "../helpers/click-area/click-area.mjs";
import { ClickAreaTrigger } from "../helpers/click-area/click-area-trigger.mjs";
import { Icon } from "../icon/icon/icon.mjs";
import { Tag } from "../tag/tag.mjs";
const Notification = (props) => {
  const { children, id, type = "info", time, isSeen, tag, button, className } = props;
  const BEM = () => {
    const classArray = ["notification", "notification--".concat(type)];
    if (!isSeen) {
      classArray.push("notification--not-seen");
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  const getIcon = () => {
    switch (type) {
      case "error":
        return "#alert";
      case "success":
        return "#check-round";
      case "attention":
        return "#alert-round";
      case "info":
      default:
        return "#info-round";
    }
  };
  return /* @__PURE__ */ React.createElement(ClickArea, null, /* @__PURE__ */ React.createElement("div", { className: BEM(), id }, /* @__PURE__ */ React.createElement("div", { className: "notification__head" }, !isSeen && /* @__PURE__ */ React.createElement(Icon, { modifiers: getIcon(), className: "notification__icon" }), tag && /* @__PURE__ */ React.createElement(Tag, { ...tag, className: "notification__tag", size: "tiny" }), /* @__PURE__ */ React.createElement("time", { dateTime: time.isoTime, className: "notification__time" }, time.formattedTime)), /* @__PURE__ */ React.createElement("div", { className: "notification__content" }, children), button && /* @__PURE__ */ React.createElement(ClickAreaTrigger, null, /* @__PURE__ */ React.createElement(Button, { ...button, className: "notification__button" }))));
};
export {
  Notification
};
